import axiosPublicClient from "../../../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/pre-check-do-not-agree`, data)

    return result.data
}

export default service
